import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { mkTrack } from '../../../marketing/track';

const FooterNav = ({ className, ...props }) => {
  const classes = classNames('footer-nav', className);

  return (
    <nav {...props} className={classes} aria-label='Footer'>
      <ul className='list-reset'>
        <li>
          <Link to='/bring-me-back' onClick={() => mkTrack('nav_click', 'bmb:footer')}>
            Bring Me Back
          </Link>
        </li>
        <li>
          <Link to='/Help' onClick={() => mkTrack('nav_click', 'help:footer')}>
            Help
          </Link>
        </li>
        <li>
          <Link to='/Privacy' onClick={() => mkTrack('nav_click', 'privacy:footer')}>
            Privacy
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default FooterNav;
